/**
 * Centralized environment configuration.
 * Public vars must be prefixed with NEXT_PUBLIC_ to be available in the browser.
 */

export const env = {
  appName: process.env.NEXT_PUBLIC_APP_NAME ?? 'DC Commercials',
  /**
   * Same-origin API base so cookies work on both :3000 and :3002.
   * Override only when pointing at an external API.
   */
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://localhost:8000/api/v1',
  userAppUrl: process.env.NEXT_PUBLIC_USER_APP_URL ?? 'http://localhost:3000',
  adminAppUrl: process.env.NEXT_PUBLIC_ADMIN_APP_URL ?? 'http://localhost:3002',
  xAccessKey: process.env.NEXT_PUBLIC_X_ACCESS_KEY ?? '',
  s3BaseUrl:
    process.env.NEXT_PUBLIC_S3_BASE_URL ??
    'https://dc-commercials-uploads-dev.s3.ap-south-1.amazonaws.com',
  recaptchaSiteKey:
    process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ||
    (process.env.NODE_ENV !== 'production' ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : ''),
} as const;
